import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AtxBreadcrumbService } from './services';
import { AtxBreadcrumbComponent } from './components';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        AtxBreadcrumbComponent,
    ],
    providers: [
        AtxBreadcrumbService,
    ],
    exports: [
        AtxBreadcrumbComponent,
    ],
})

export class AtxBreadcrumbModule {}
